import {Controller} from "@hotwired/stimulus"
import flatpickr from "flatpickr";

// Connects to data-controller="checkout-ticket-select"
export default class extends Controller {
  static targets = ['dateField', 'selectionLabel', 'ticketsSubtitle']

  static values = {
    range: String,
    // "Tickets shown are for %{day}." with %{day} swapped client-side.
    subtitleTemplate: { type: String, default: "Tickets shown are for {day}." },
  };

  connect() {
    const config = this.buildFlatpickrConfig()
    if (this.hasDateFieldTarget) this.picker = flatpickr(this.dateFieldTarget, config);
  }

  openDatePicker() {
    this.picker.open();
  }

  buildFlatpickrConfig() {
    const config = {
      altInput: true,
      altFormat: "m-d-Y",
      dateFormat: "Y-m-d",
      onChange: this.handleDateChange.bind(this),
    };

    const enabled = this.hasRangeValue
      ? this.rangeValue.split(",").map((date) => date.trim()).filter(Boolean)
      : [];
    config.enable = enabled;

    // Open the calendar on the FIRST available date (the dates are pre-sorted),
    // not the current month — otherwise an event whose next date is in a future
    // month opens on a fully-greyed-out current month.
    if (enabled.length) {
      const firstAvailable = enabled.slice().sort()[0];
      config.minDate = firstAvailable;
      config.defaultDate = firstAvailable;
    }
    return config;
  }

  handleDateChange(selectedDates, dateStr) {
    this.enableTickets(dateStr)
  }

  selectDate() {
    this.enableTickets(event.currentTarget.dataset.date)
  }

  enableTickets(dateStr) {
    document.querySelectorAll(`[data-action="click->checkout-ticket-select#selectDate"]`).forEach((dateBox) => {
      dateBox.classList.remove('active')
    })
    const activeBox = document.querySelector(`[data-date="${dateStr}"]`)
    if (activeBox) activeBox.classList.add('active')

    let allDates = document.querySelectorAll(`[data-ticket-bundle="bundleWrapper"]`)

    allDates.forEach((dateWrapper) => {
      dateWrapper.classList.add('d-none')
    })

    document.getElementById(dateStr).classList.remove('d-none')

    this.updateSelectionLabels(activeBox, dateStr)
  }

  // Keep the "You're selecting tickets for …" banner and the step-2 subtitle in
  // sync with the chosen date. Prefer the box's prebuilt labels; fall back to the
  // raw date for picks made via the calendar (dates beyond the visible chips).
  updateSelectionLabels(activeBox, dateStr) {
    let label = dateStr
    if (activeBox) {
      const day = activeBox.dataset.dayLabel
      const time = activeBox.dataset.timeLabel
      label = [day, time].filter(Boolean).join(" · ")
    }

    if (this.hasSelectionLabelTarget) this.selectionLabelTarget.textContent = label
    if (this.hasTicketsSubtitleTarget) {
      this.ticketsSubtitleTarget.textContent = this.subtitleTemplateValue.replace("{day}", label)
    }
  }
}
